import { ActionMultiProperty } from "./PropertyType/ActionMultiProperty";
import { ActionGroupProperty } from "./PropertyType/ActionGroupProperty";
import { ActionValueProperty } from "./PropertyType/ActionValueProperty";
import { Stack, Typography } from "@mui/material";
import { SsqProperty } from "src/api/sure-api/actions/useGetOneAction";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { useMyActionPlanContext } from "../../../../context/useMyActionPlan";

type ActionPropertyProps = {
    property: SsqProperty;
    value?: string;
};
const ActionPropertyField = (props: ActionPropertyProps) => {
    const { property, value } = props;
    const { isEditMode } = useMyActionPlanContext();
    const { savingStatus } = useActionsContext();

    const isDisabled = isEditMode === false || savingStatus.isSaving;

    if (property?.children?.length) {
        if (property.multivalue) {
            return <ActionMultiProperty property={property} />;
        }

        return <ActionGroupProperty property={property} />;
    }

    return <ActionValueProperty property={property} value={value} disabled={isDisabled} />;
};

export const ActionPropertyInput = (props: ActionPropertyProps) => {
    const { property } = props;

    return (
        <Stack spacing={1.5}>
            <Typography variant="h4">{property.title}</Typography>
            <ActionPropertyField {...props} />
        </Stack>
    );
};
